import template from './usersEditForm.html';
import './usersEditForm.scss';

class UsersEditFormController {
  constructor($scope) {
    'ngInject';

    this.$scope = $scope;
    this.userInfo = {
      name: '',
      email: '',
    };

    this.errors = Object.assign({ all: '' }, this.userInfo);
    this.errorsRegex = {
      usedEmail: /a user account with .*? already exists\.$/i,
    };
  }
  $onInit() {
    this.userInfo.name = this.userName;
    this.userInfo.email = this.userEmail;
  }
  $onChanges({ error }) {
    if (error && error.currentValue) {
      if (this.errorsRegex.usedEmail.test(error.currentValue)) {
        this.errors.email = 'A user account with this email address already exists.';
      } else {
        this.errors.all = error.currentValue;
      }
    }
  }
  cancel() {
    this.onCancel();
  }
  save() {
    if (!this.loading) {
      this._resetErrors();

      if (this.form.$valid) {
        this.onSave({
          userInfo: this.userInfo,
        });
      } else if (this.form.$error.email) {
        this.errors.email = 'Please enter a valid e-mail address';
      } else {
        this._markErrorOnRequiredFields();
      }
    }
  }
  get form() {
    return this.$scope.nzEditUserForm_form;
  }
  _resetErrors() {
    Object.keys(this.errors).forEach((fieldName) => {
      this.errors[fieldName] = '';
    });
  }
  _markErrorOnRequiredFields() {
    ['name', 'email']
    .forEach((fieldName) => {
      this.errors[fieldName] = this.userInfo[fieldName] ?
        '' :
        'Please complete this field';
    });
  }
}

export default {
  controller: UsersEditFormController,
  template,
  bindings: {
    loading: '<',
    error: '<',
    userName: '<',
    userEmail: '<',
    onSave: '&',
    onCancel: '&',
  },
};
